import React, { useState } from 'react'
import Layout from '../../components/Layout/Layout'
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io'
import { useTranslation } from 'react-i18next'

const Faq = () => {
    const [active, setActive] = useState(null)

    const handleToggle = (i) => {
        if (i === active) {
            setActive(null)
        } else {
            setActive(i)
        }
    }

    const { t } = useTranslation()
    const listFaq = [t('faq_1'), t('faq_2'), t('faq_3'), t('faq_4'), t('faq_5'), t('faq_6'),]
    const farAnswers = [t('faq_text1'), t('faq_text2'), t('faq_text3'), t('faq_text4'), t('faq_text5'), t('faq_text6')]
    return (
        <Layout>
            <div className="container mx-auto mt-7">
                <div className="-mx-4 flex flex-wrap">
                    <div className="w-full px-4">
                        <div className="mx-auto mb-[60px] max-w-[520px] text-center lg:mb-20">
                            <span className="mb-2 block font-bold text-5xl ">
                                {t('faq')}
                            </span>
                            <h2
                                className="mb-4 text-xl font-bold text-dark sm:text-4xl md:text-[40px]"
                            >
                                Any Questions? Look Here
                            </h2>
                            {/* <p className="text-base text-body-color">
                                There are many variations of passages of Lorem Ipsum available but
                                the majority have suffered alteration in some form.
                            </p> */}
                        </div>
                    </div>
                </div>

                <div className="w-full px-4 ">
                    <div className='grid lg:grid-cols-2 gap-5'>
                        {
                            listFaq?.map((item, i) => (

                                <div
                                    className=" mb-8 w-full rounded-lg border border-[#F3F4FE] bg-white p-4 sm:p-8 lg:px-6 xl:px-8"
                                    key={i}
                                >
                                    <button
                                        className=" flex w-full text-left"
                                    >
                                        <div
                                            className="mr-5 flex h-10 w-full max-w-[40px] items-center justify-center rounded-lg bg-blue-500 bg-opacity-5 text-blue-500"
                                            onClick={() => handleToggle(i)}
                                        >
                                            {
                                                active === i ?
                                                    <IoIosArrowDown className='text-[20px] font-bold' />
                                                    :
                                                    <IoIosArrowUp className='text-[20px] font-bold' />
                                            }
                                        </div>
                                        <div className="w-full">
                                            <h4 className="text-lg font-semibold text-black">
                                                {item}
                                            </h4>
                                        </div>
                                    </button>
                                    {
                                        active === i &&
                                        <div className=" pl-[62px]">
                                            <p
                                                className="py-3 text-base leading-relaxed text-body-color"
                                                dangerouslySetInnerHTML={{ __html: farAnswers[i] }}
                                            />
                                        </div>
                                    }
                                </div>
                            ))
                        }
                    </div>

                </div >
            </div >

        </Layout >
    )
}

export default Faq